<template>
  <div>
    <span>
      <span v-if="data.length<maxLen">
        <span class="tj">{{data}}</span>
      </span>
      <span v-else>
        <span class="tj">{{showBtn?sliceStr:data}}
          <span @click="showBtn=!showBtn" class="showText">{{showBtn?tip:'收起'}}</span>
          <img class="btnWord" v-if="$route.path.indexOf('/actKeys') != -1"
            :src='showBtn?"/static/img/actKeys/index/dropDown.png":"/static/img/actKeys/index/dropUp.png"'>
        </span>
      </span>
    </span>
  </div>

</template>

<script>
  export default {
    name: "unfold",
    data() {
      return {
        showBtn: true,
      }
    },

    props: {
      tip: {
        type: String,
        // default: '/static/img/sellingTime/dropDown.png'
        default: '展开'
      },
      // 数据
      data: {
        type: String,
        default: ''
      },
      // 最大长度
      maxLen: {
        type: String,
        default: 80
      },
    },
    computed: {
      sliceStr() {
        if (this.data != null) {
          return this.data.substring(0, this.maxLen) + "...";
        }
        return '';
      }
    },
  }

</script>

<style lang="less" scoped>
  .tj {
    text-align: justify;
    line-height: 1.8em;
    display: inline-block;
    font-family: PingFangSC-Light, PingFang SC;
    font-size: 12px;
    font-weight: 300;
    color: #999;
    margin-bottom: 30px;

    .showText {
      font-weight: 300;
      font-size: 12px;
      color: #fff;
      font-family: SourceHanSansCN-Light, SourceHanSansCN;
    }
  }

  .btnWord {
    // cursor: pointer;
    word-break: keep-all;
    vertical-align: middle;
    width: 17px;
    height: 17px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Unfold.vue